import { render, staticRenderFns } from "./EditImageNotes.vue?vue&type=template&id=0362a0fe&"
import script from "./EditImageNotes.vue?vue&type=script&lang=js&"
export * from "./EditImageNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports